import { useTippingCardForm } from "@/components/shared/forms/tipping-card-form";
import type { Tipping1Card, Tipping2Card } from "@stackje/common/config";

export function EditTippingCard({ 
  card, 
}: { 
  card: Tipping1Card | Tipping2Card; 
  cardIndex: number; 
}) {
  const { formContent, previewContent, shuffleColors, toggleType, handleSubmit } = useTippingCardForm({
    initialData: {
      title: card.title,
      description: card.description || "",
      paymentMethod: card.paymentMethod,
      payeeInfo: {
        paynow: card.payeeInfo?.paynow || {
          type: "MOBILE" as const,
          value: "",
          recipientName: "",
        },
      },
      amounts: card.amounts,
      allowCustomAmount: card.allowCustomAmount,
      minAmount: card.minAmount,
      maxAmount: card.maxAmount,
      currency: card.currency,
      buttonText: card.buttonText,
      thankYouNote: card.thankYouNote,
      type: card.type,
      colors: card.colors,
    },
    mode: "edit",
  });

  return {
    formContent,
    previewContent,
    shuffleColors,
    toggleType,
    handleSubmit,
  };
}